var map = {
	"./en-SG": 829,
	"./en-SG.js": 829,
	"./en-au": 830,
	"./en-au.js": 830,
	"./en-ca": 831,
	"./en-ca.js": 831,
	"./en-gb": 832,
	"./en-gb.js": 832,
	"./en-ie": 833,
	"./en-ie.js": 833,
	"./en-il": 834,
	"./en-il.js": 834,
	"./en-nz": 835,
	"./en-nz.js": 835
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1960;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 1960
// module chunks = 1